import { ManifestSecretAzureOpenAI } from './common/ManifestCommonAzureOpenAI';
import { ManifestCommonGoogleVertexAISecret } from './common/ManifestCommonGoogleVertexAI';
import { ManifestSecretOpenAI } from './common/ManifestCommonOpenAI';

export const SECRET_SPECIFIC_MAP = {
  OPENAI_API_KEY: ManifestSecretOpenAI,
  AZURE_OPENAI_API_KEY: ManifestSecretAzureOpenAI,
  GOOGLE_VERTEX_AI_WEB_CREDENTIALS: ManifestCommonGoogleVertexAISecret,
};
